// smokeVisibility.js - smoke-test media control (AIT-255).
// stopSmokeMedia stops ALL smoke-related media (video, spoken-answer audio,
// speech synthesis). attachSmokeVisibilityPause calls it when the tab becomes
// hidden while a smoke run is active; it accepts either a video getter
// function (legacy) or an options object { getVideo, stopAudio, speech }.
// Returns an unsubscribe function.

const tryStep = (label, fn) => {
  try {
    fn();
  } catch (e) {
    console.warn(`[SMOKE] could not ${label}`, e);
  }
};

export const stopSmokeMedia = ({ getVideo, stopAudio, speech } = {}) => {
  tryStep("pause video", () => getVideo?.()?.pause?.());
  tryStep("stop audio", () => stopAudio?.());
  tryStep("cancel speech", () => speech?.cancel?.());
};

export const attachSmokeVisibilityPause = (
  mediaOrGetVideo,
  doc = typeof document !== "undefined" ? document : null
) => {
  if (!doc || typeof doc.addEventListener !== "function") return () => {};
  const media =
    typeof mediaOrGetVideo === "function"
      ? { getVideo: mediaOrGetVideo }
      : mediaOrGetVideo || {};
  const onChange = () => {
    if (doc.visibilityState !== "hidden") return;
    stopSmokeMedia(media);
  };
  doc.addEventListener("visibilitychange", onChange);
  return () => doc.removeEventListener("visibilitychange", onChange);
};
